export {
  /**
   * @deprecated Use shared/providers/notices
   */
  useNotices,
} from '@/shared/providers/notices';
